function Dashboard() {
  return (
    <div className="flex flex-col">
      <div className="flex flex-row p-4 space-x-2 h-18">
        <div className="font-mono font-bold text-xl text-title pt-1">VIOLATIONS</div>
        <div className="flex-grow"></div>
        <div className="bg-white border border-gray-300 rounded-md p-2 cursor-pointer shadow-inner shadow-sm hover:shadow-md">
          <div className="font-mono text-dark text-xs align-center">PRINT</div>
        </div>
        <div className="bg-white border border-gray-300 rounded-md p-2 cursor-pointer shadow-inner shadow-sm hover:shadow-md">
          <div className="font-mono text-dark text-xs align-center">EXPORT</div>
        </div>
        <div className="bg-green-300 border border-green-400 rounded-md p-2 cursor-pointer shadow-inner shadow-sm hover:shadow-md">
          <div className="font-mono text-white text-xs align-center">CREATE VIOLATION</div>
        </div>
      </div>
      <div className="bg-less-dark pl-4 pr-4">
        <div className="border-t"></div>
        <div className="pt-4"> CREATED REF </div>
      </div>
      <div> Table </div>
    </div>
  );
}

export default Dashboard;
